import React from "react";
import {
  ScreenFlow,
  RecruitmentSteps,
} from "../../components";

const flowarray = [
  { title: "Home", link: "/" },
  { title: "Find Trials", link: "/#find_trial" },
  {
    title: "Search Results",
    link: `/results?q=NCT04538989&in=UNITED%20STATES`,
  },
  {
    title: "Trial Details",
    link: `/study/NCT04538989`,
  },
];

class NCT04538989 extends React.Component {
  
  render() {
    return (
      <div>
        {this.props.location &&
        this.props.location.search &&
        this.props.location.search.indexOf("embed=true") !== -1 ? null : (
          <>
            <RecruitmentSteps step={"Review Trials"} />
            <div className="container d-flex align-items-center justify-content-start">
              <ScreenFlow flow={flowarray} />
            </div>
          </>
        )}
        <div className="container">
          <iframe style={{height:3600,width:'100%',border:'none'}} title="NCT04538989" src="https://connect.trialscope.com/studies/93e491ca-4549-4e9d-b2ef-7952053dcd4b?embed=1"></iframe>
        </div>
      </div>
    );
  }
}

export default NCT04538989;
